var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 142,
    viewBox: "0 0 142 142",
    width: 142,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m142 71c0-39.2127083-31.787292-71-71-71-39.2117222 0-71 31.7872917-71 71 0 39.212708 31.7882778 71 71 71 39.212708 0 71-31.787292 71-71zm-39.493072 3.4038212-43.1559755 26.6373138c-1.8798786 1.160324-4.3444497.57701-5.5047737-1.3028687-.3897583-.6314601-.5961788-1.3588923-.5961788-2.1009525v-53.2746276c0-2.209139 1.790861-4 4-4 .7420602 0 1.4694924.2064205 2.1009525.5961788l43.1559755 26.6373138c1.879879 1.160324 2.463193 3.6248951 1.302869 5.5047737-.326985.5297593-.773109.9758835-1.302869 1.3028687z",
    fill: "#fefefe",
    fillRule: "evenodd",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayTransparent);
export default __webpack_public_path__ + "static/media/PlayTransparent.3f464100a94e7ffcc0c30d148cff6ea2.svg";
export { ForwardRef as ReactComponent };